import React, { useState, useCallback, useRef, useEffect } from 'react'; //import { useNavigate } from "react-router-dom";
import logo from '../wipe-dark.png'; // Import your logo image
import logout from '../wipe-dark.png'; // Import your logo image
import account from '../wipe-light.png'; // Import your logo image
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  useColorModeValue,
  CardBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Image,
  Text,
  Box,
  Switch,
} from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';

const Upload = ({ setAuthenticated }) => {
  //Color shit:

  const bgColor = useColorModeValue('#f0eded', '#0f0f0f');
  const textColor = useColorModeValue('black', 'white');
  const containerBgColor = useColorModeValue(
    'rgba(255, 255, 255, 0.8)',
    'rgba(31, 31, 31, 0.8)'
  );
  const buttonBgColor = useColorModeValue('#fff', '#333');
  const buttonTextColor = useColorModeValue('#0c0c0c', 'black');
  const dropZoneColor = useColorModeValue('black', 'white');
  const selectTextColor = useColorModeValue('grey', 'lightgrey');
  const selectBgColor = useColorModeValue('#fff', '#2b2a33');

  //other shit:
  const [videoSrc, setVideoSrc] = useState(null);
  const [check, setCheck] = useState(null);

  const [videoFile, setVideoFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadValue, setUploadValue] = useState('Upload');
  const [title, setTitle] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [hashtags, setHashtags] = useState([]);
  const [isEnabled, setIsEnabled] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);
  const playvideo = useRef(null);
  const navigate = useNavigate();
  const handleChange = selectedOptions => {
    if (selectedOptions.length <= 3) {
      setHashtags(selectedOptions);
    }
  };
  const [startDate, setStartDate] = useState(new Date());
  
  

  const hashtagOptions = [
    { value: '#Meme', label: '#Meme' },
    { value: '#Vlogs', label: '#Vlogs' },
    { value: '#Food', label: '#Food' },
    { value: '#Gaming', label: '#Gaming' },
    { value: '#Travel', label: '#Travel' },
    { value: '#Sport', label: '#Sport' },
    { value: '#DIY', label: '#DIY' },
    { value: '#Animals', label: '#Animals' },
    { value: '#Tech', label: '#Tech' },
    { value: '#Fashion', label: '#Fashion' },
    { value: '#Music', label: '#Music' },
    { value: '#Art', label: '#Art' },
    { value: '#Science', label: '#Science' },
    { value: '#Fitness', label: '#Fitness' },
    { value: '#Politics', label: '#Politics' },
  ];

  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      setVideoSrc(videoUrl);
      setVideoFile(file);
    }
  }, []);
  const handleUpload = async () => {
    if (!videoFile) {
      alert("No video selected! Please select a video before uploading.");
      return;
    }
  
    setIsLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("video", videoFile);
    formData.append("categories", JSON.stringify(hashtags.map((h) => h.value)));
  
    // Conditionally add the scheduled time if it exists
    if (startDate) {
      const formattedDate = startDate.toISOString().slice(0, 19).replace("T", " ");
      formData.append("scheduled_time", formattedDate);
    }
  
    const endpoint = check
      ? "https://api.wipe.wtf/plannedupload"
      : "https://api.wipe.wtf/uploadVideo";
  
    try {
      const accessToken = localStorage.getItem("accessToken");
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (event) => {
          if (event.total) {
            const percentage = Math.round((event.loaded * 100) / event.total);
            setUploadValue(percentage + "%");
            console.log(`Upload progress: ${percentage}%`);
          }
        },
      };
  
      const response = await axios.post(endpoint, formData, config);
      const data = response.data;
      console.log("Response data:", data);
  
      if (data === "true") {
        if (playvideo.current) playvideo.current.unloadAsync();
        navigate("/success");
        setTitle("");
        setVideoSrc(null);
        setIsLoading(false);
        setModalVisible2(!modalVisible2);
      }
    } catch (error) {
      console.error("Error during upload:", error);
      alert("Upload unsuccessful!");
      setIsLoading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'video/*',
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1140);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div
      style={{
        position: 'relative',
        height: window.innerWidth < 753 ? '100vh' : '70vh',
        justifyContent: 'center',
        alignSelf: 'center',
        alignContent: 'center',
      }}
    >
      <div
        style={{
          margin: 'auto',
          width: window.innerWidth < 753 ? '90%' : '90%',
          maxWidth: '100%',
          maxWidth: '90vh',
          color: textColor,
          backgroundColor: bgColor,
          padding: '55px',
          paddingTop: '30px',
          paddingBottom: '30px',
          borderRadius: '15px',
          backdropFilter: 'blur(20px)',
          boxShadow: useColorModeValue(
            '0px 0px 20px rgba(9, 9, 9, 0.17)',
            '0px 0px 20px rgba(9, 9, 9, 0.1)'
          ),
        }}
      >
        {videoSrc ? (
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row', // Column for mobile, row for desktop
              justifyContent: isMobile ? 'space-between' : 'flex-start',
              alignItems: 'flex-start',
              gap: '20px',

              flexWrap: 'wrap',
            }}
          >
            {/* Video Section */}
            <div
              style={{
                //flex: '1',
                alignSelf: 'center',
                width: isMobile ? '100%' : '50%',
              }}
            >
              <video
                style={{
                  borderRadius: '25px',
                }}
                muted
                autoPlay
              >
                <source src={videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Input Section */}
            <div
              style={{
                //  flex: '1',

                maxWidth: isMobile ? undefined : '50%',
                width: isMobile ? '100%' : undefined,

                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              {/* Title Input */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <input
                  type="text"
                  placeholder="Video Title"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '15px',
                    border: '1px solid #ccc',
                    marginBottom: '10px',
                    boxSizing: 'border-box',
                    color: textColor,
                    backgroundColor: selectBgColor,
                  }}
                />

                <Select
                  isMulti
                  options={hashtagOptions}
                  value={hashtags}
                  onChange={handleChange}
                  placeholder="#Hashtags"
                  styles={{
                    container: base => ({
                      ...base,
                      marginTop: '5px',
                      color: selectTextColor,
                      fontSize: 14,
                      textAlign: 'left',
                      marginBottom: '10px',
                    }),
                    control: base => ({
                      ...base,
                      padding: '5px',
                      borderRadius: '15px',
                      borderColor: '#ccc',
                      backgroundColor: selectBgColor,
                    }),
                  }}
                />
                <Box display="flex" alignItems="center" width="300px">
                  <Text fontSize="md" mr="3">
                    Planned Upload:
                  </Text>
                  <Switch
                    isChecked={check}
                    onChange={() => setCheck(!check)}
                    size="md"
                    colorScheme="teal"
                  />
                </Box>
              </div>
              {check ? (
                <div
                  style={{
                    backgroundColor: selectBgColor,
                    padding: 14,
                    borderRadius: 15,
                    borderColor: selectBgColor,
                    borderWidth: 1,
                  }}
                >
                  <div
                    style={{
                      borderColor: '#cccccc',
                      borderWidth: 1,
                      borderRadius: 5,
                      padding: 3,
                    }}
                  >
                    <DatePicker
                      selected={startDate}
                      onChange={date => setStartDate(date)}
                      showTimeSelect
                      backgroundColor={selectBgColor}
                      timeFormat="HH:mm"
                      style={{width:"100%"}}
                      timeIntervals={15} // Set time intervals (e.g., every 15 minutes)
                      dateFormat="MMMM d, yyyy h:mm aa"
                      placeholderText="Select date and time"
                    />
                  </div>
                  <Text>⚠️ This is a beta feature!</Text>
                </div>
              ) : (
                <div
                  style={{
                    padding: 14,
                    borderRadius: 15,
                    height: '86px',
                  }}
                />
              )}

              {/* Upload Button */}
              {isMobile ? (
                <button
                  onClick={handleUpload}
                  style={{
                    marginTop: 40,

                    bottom: '60px',
                    backgroundColor: 'white',
                    color: buttonTextColor,
                    padding: '15px',
                    borderRadius: '15px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    width: '100%',
                    right: 60,
                  }}
                >
                  {uploadValue}
                </button>
              ) : (
                <button
                  onClick={handleUpload}
                  style={{
                    position: 'absolute',

                    bottom: '60px',
                    backgroundColor: 'white',
                    color: buttonTextColor,
                    padding: '15px',
                    borderRadius: '15px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    width: window.innerWidth < 500 ? '75%' : '40%',
                    right: 60,
                  }}
                >
                  {uploadValue}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div
            {...getRootProps()}
            style={{
              border: '2px ',
              padding: '50px',
              textAlign: 'center',
              color: dropZoneColor,
              borderRadius: '10px',
            }}
          >
            <input style={{height:"100px", padding:"100px"}}{...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here...</p>
            ) : (
              <h3>Drag and drop your video here.</h3>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Upload;
